import styled from 'styled-components';
import Image from '@stencil/image';

export const GoSafeMainContainer = styled.div(
  props => `
    display: flex;
    align-items:center;
    width: fit-content;
    border-radius: ${props.theme.misc.borderRadius.large};
    background-color: ${props.backgroundColor || props.theme.colors.goGreen.light};
    padding:${props.theme.spacing.small};
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.goTeal.medium};
    `,
);

export const TextContentBoldSpan = styled.span(
  props => `
  font-weight: bold;
  padding-left:${props.theme.spacing.small};
`,
);

export const TextContentNormalSpan = styled.span(
  props => `
  padding-left:${props.theme.spacing.small};
  color: ${props.color};
`,
);

export const GosafeImg = styled(Image)(
  props => `
  width: ${props.width || '5rem'};
  height: ${props.height || '1.5rem'};
  object-fit: contain;
    `,
);
